// extracted by mini-css-extract-plugin
export default {"inputContainer":"WSTextArea-module_inputContainer-GooID","error":"WSTextArea-module_error-vpXz6","input":"WSTextArea-module_input-fktxG"};